import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

export const onBookmarkRequestsCompleted = (props: {
	searchSessionId: string;
	queryHash: string;
	source: string;
	bookmarkAPIHasBookmark: boolean;
	queryIntentHasBookmark: boolean;
	bookmarkAPIBookmarkId: string | undefined;
	queryIntentBookmarkId: string | undefined;
	bookmarkAPIRequestId: string | null;
	queryIntentRequestId: string | null;
	bookmarksAreEqual: boolean;
}): AnalyticsEventPayload => {
	const {
		searchSessionId,
		queryHash,
		source,
		bookmarkAPIHasBookmark,
		queryIntentHasBookmark,
		bookmarkAPIBookmarkId,
		queryIntentBookmarkId,
		bookmarkAPIRequestId,
		queryIntentRequestId,
		bookmarksAreEqual,
	} = props;
	return {
		action: 'completed',
		actionSubject: 'aiSearchBookmarkRequests',
		eventType: 'operational',
		source,
		attributes: {
			searchSessionId,
			queryHash,
			bookmarkAPIHasBookmark,
			queryIntentHasBookmark,
			bookmarkAPIBookmarkId,
			queryIntentBookmarkId,
			bookmarkAPIRequestId,
			queryIntentRequestId,
			bookmarksAreEqual,
		},
	};
};
